<div class="performer-selector-container">
  <div class="selector-modal">
    <div class="close-button-container">
      <mat-icon class="close-button mat-icon" aria-hidden="true" data-mat-icon-type="font" (click)="close()"
        >close</mat-icon
      >
    </div>
    <div class="header">
      <label class="title">Presenters</label>
      <label class="sub-title"
        >Select up to four presenters from the people in this room, then start their presentation.</label
      >
    </div>

    <div class="flex items-center justify-start gap-10 m-b-16 wrap">
      @for (presenter of selectedPresenters; track presenter) {
        <app-chip (accessoryRightClick)="unselectPresenter(presenter?.userId)" [text]="getPresenterName(presenter)">
          <div accessory-left>
            <profile-picture [size]="28" [user]="presenter" [borderWidth]="'0'"></profile-picture>
          </div>
          <div accessory-right>
            <svg
              class="m-l-4 m-r-4"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="24" height="24" rx="12" fill="#F2F2F2" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.19922 16.0706L7.92779 16.8002L11.9992 12.7292L16.0707 16.8002L16.7992 16.0706L12.7283 12.0002L16.7992 7.92979L16.0707 7.2002L11.9992 11.2712L7.92779 7.2002L7.19922 7.92979L11.2701 12.0002L7.19922 16.0706Z"
                fill="#333333"
              />
            </svg>
          </div>
        </app-chip>
      }
      @if (isLivestreamActive) {
        <div>
          @for (stream of livestreamPresenters; track stream) {
            <app-chip (accessoryRightClick)="removeLivestream(stream)" [text]="getLivestreamTitle(stream)">
              <div accessory-right>
                <svg
                  class="m-l-4 m-r-4"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="24" height="24" rx="12" fill="#F2F2F2" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.19922 16.0706L7.92779 16.8002L11.9992 12.7292L16.0707 16.8002L16.7992 16.0706L12.7283 12.0002L16.7992 7.92979L16.0707 7.2002L11.9992 11.2712L7.92779 7.2002L7.19922 7.92979L11.2701 12.0002L7.19922 16.0706Z"
                    fill="#333333"
                  />
                </svg>
              </div>
            </app-chip>
          }
        </div>
      }
      @if (!isLivestreamActive) {
        <div>
          @for (livestream of selectedLivestream | keyvalue; track livestream) {
            <app-chip
              (accessoryRightClick)="removeLivestream(livestream.value)"
              [text]="getLivestreamTitle(livestream.value)"
            >
              <div accessory-right>
                <svg
                  class="m-l-4 m-r-4"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="24" height="24" rx="12" fill="#F2F2F2" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.19922 16.0706L7.92779 16.8002L11.9992 12.7292L16.0707 16.8002L16.7992 16.0706L12.7283 12.0002L16.7992 7.92979L16.0707 7.2002L11.9992 11.2712L7.92779 7.2002L7.19922 7.92979L11.2701 12.0002L7.19922 16.0706Z"
                    fill="#333333"
                  />
                </svg>
              </div>
            </app-chip>
          }
        </div>
      }
      @if (showAddLivestream) {
        <app-chip
          class="add-livestream presenter-chip"
          (accessoryRightClick)="handleClickAddLivestream()"
          text="Add Livestream"
        >
          <div accessory-right>
            <img role="presentation" height="24" width="24" src="assets/images/Plus.svg" class="plus-icon" />
          </div>
        </app-chip>
      }
    </div>

    <div class="content">
      @if (notPresenters.length > 0 && selectedPresenters.length < 4) {
        <div class="selector">
          <div class="search-field">
            <mat-icon>search</mat-icon>
            <input
              class="selector-search"
              placeholder="Search"
              [(ngModel)]="search"
              (ngModelChange)="onSearchChanged()"
            />
          </div>
          <ul class="selector-options">
            @for (participant of notPresenters; track participant) {
              <li class="selector-item" (click)="selectParticipant(participant)" data-testid="presenter-item">
                <profile-picture [size]="45" [user]="participant" [borderWidth]="'0'"> </profile-picture>
                <span>{{ participant.firstName }} {{ participant.lastName || '' }}</span>
              </li>
            }
          </ul>
        </div>
      }
    </div>
    <div class="footer flex flex-column">
      @if (crossRoomPresentationEnabled && !presentationInProgress && isConnectedRoom) {
        <div class="m-b-24 m-t-10 flex justify-center items-center cross-room-presentation-toggle">
          <span class="m-r-8 cross-room-presentation-toggle-label">Present to this room</span>
          <mat-slide-toggle
            [checked]="isCrossRoom"
            (change)="onCrossRoomToggle($event)"
            [disabled]="isSomeoneElsePresenting"
          ></mat-slide-toggle>
          <span class="m-l-8 cross-room-presentation-toggle-label">Present to all rooms </span>
          <mat-icon
            class="help-icon m-l-10"
            svgIcon="help-icon"
            aria-hidden="false"
            arial-label="Info Icon"
            matTooltip="To learn more about connected rooms, contact sales@scoot.app"
            matTooltipPosition="after"
          ></mat-icon>
        </div>
      }
      <button
        data-testid="start-presentation-button"
        mat-button
        class="rounded shadow"
        (click)="presentationInProgress ? onUpdatePresentation() : onStartPresentation()"
        [disabled]="submitDisabled"
        [matTooltipDisabled]="!submitDisabled"
        matTooltip="Must select between 1 and 4 presenters"
        matTooltipPosition="after"
      >
        {{ submitButtonText }}
      </button>
    </div>
  </div>
</div>
